import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from './../../../environments/environment';
import { AuthService } from '../../core/authentication/auth.service';
import { Subscription } from 'rxjs';
import { Profile } from 'selenium-webdriver/firefox';
import { Shell } from '../shell.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  name: string;
  role: string;
  isAdmin: boolean;
  isAuthenticated: boolean;
  subscription: Subscription;
  title: string;
  headerNotify: any;
  showPasswordExpiryWarning = false;
  passwordExpiryDays= 99;

  constructor(public authService: AuthService, private service: Shell, private router: Router) { }

  ngOnInit() {
    this.subscription = this.authService.authNavStatus$.subscribe(status => this.isAuthenticated = status);
    this.name = this.authService.name;
    //this.role = this.authService.canalGroup;
    this.isAdmin = this.authService.isAdmin;
    this.title = environment.title;

    const daysRemaining = parseInt(this.authService.password_expiry_days_remaining, 10);

    if (daysRemaining <= 5) {
      this.showPasswordExpiryWarning = true;
      this.passwordExpiryDays = daysRemaining;
    }
  }

  login() {
    this.authService.login();
  }

   async signout() {
    await this.authService.signout();
  }

  ngOnDestroy() {
    // prevent memory leak when component is destroyed
    this.subscription.unsubscribe();
  }

  redirectToChangePassword() {
    window.location.href = environment.authUrl + 'Identity/Account/ChangePassword'; // Ajusta la ruta según tu aplicación
  }

}
